import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GatewayComponent} from '@components/administration/gateway/gateway.component';
import {
  GatewayConfigurationComponent
} from '@components/administration/gateway/gateway-configuration/gateway-configuration.component';
import {AuthorizationGuardService} from 'src/app/shared/authorization-guard/authorization-guard.service';
import {USER_ROLE} from '@constants/user-role.constant';

const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {
    path: 'gateways', component: GatewayComponent, canActivate: [AuthorizationGuardService],
    data: {roles: [USER_ROLE.DISTRIBUTOR, USER_ROLE.ADMIN, USER_ROLE.TECH_ADMIN, USER_ROLE.SUPERADMIN]}
  },
  {
    path: 'gateways/:details', component: GatewayConfigurationComponent, canActivate: [AuthorizationGuardService],
    data: {roles: [USER_ROLE.ADMIN, USER_ROLE.TECH_ADMIN, USER_ROLE.SUPERADMIN]}
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ]
})
export class GatewayRoutingModule {
}
